import React from 'react'
import { Link } from 'react-router-dom';


import watsap from "../imgz/WhatsApp-Logo.png";
import chat from "../imgz/chatxx.gif";


function Watsap() {
    return (
        <div>
        <Link to="/wasap" style={{textDecoration: "none"}}>
                <div className="lin">
                <img src={watsap} alt="" className="grande" />
                <img src={chat} alt="" className="sign" />
                </div>
                </Link>
    
        </div>
    )
}

export default Watsap
